import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'
import { useAttendants } from '../context/attendants-context'

export function AttendantsPrimaryButtons() {
  const { setOpen } = useAttendants()

  return (
    <Button onClick={() => setOpen('create')}>
      <Plus className="mr-2 h-4 w-4" />
      Novo Atendente
    </Button>
  )
} 